import PropTypes from 'prop-types';
import classNames from 'classnames';

import './style.scss';

const TextArea = ({ onChange, value, type, className, ...props }) => {
	const classes = classNames(className, 'eform-gtb-textarea');
	return (
		<textarea
			value={value}
			onChange={onChange}
			className={classes}
			{...props}
		/>
	);
};

TextArea.propTypes = {
	onChange: PropTypes.func.isRequired,
	value: PropTypes.string.isRequired,
	className: PropTypes.string,
};
TextArea.defaultProps = {
	className: null,
};

export default TextArea;
